// Handwriting fonts for typed signatures (FR-14). next/font downloads them at
// build time and serves them from this site, so typing a name never contacts Google.
import { Caveat, Dancing_Script, Great_Vibes } from "next/font/google";

const caveat = Caveat({ subsets: ["latin"], weight: "600", display: "swap" });
const dancing = Dancing_Script({
  subsets: ["latin"],
  weight: "600",
  display: "swap",
});
const vibes = Great_Vibes({
  subsets: ["latin"],
  weight: "400",
  display: "swap",
});

export const SIGNATURE_FONTS = [
  {
    id: "caveat",
    label: "Casual",
    family: caveat.style.fontFamily,
    className: caveat.className,
  },
  {
    id: "dancing",
    label: "Classic",
    family: dancing.style.fontFamily,
    className: dancing.className,
  },
  {
    id: "vibes",
    label: "Formal",
    family: vibes.style.fontFamily,
    className: vibes.className,
  },
] as const;

export type SignatureFont = (typeof SIGNATURE_FONTS)[number];
